import React from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './page.component.module.styl';

import type {ComponentProps} from 'react';


const classNames = withCssModule(styles);

/**
 * Semantic `<main>` content region of a `<Page>` layout.
 *
 * Renders a `<main>` element with the `page__main` layout class. Place
 * `<MainFrame>` or page-specific content directly inside. Satisfies the
 * WAI-ARIA requirement for a single `<main>` landmark per page.
 */
export const PageMain = (props: ComponentProps<'main'>) => {
    const {className, children, ...mainProps} = props;
    const classes = classNames('page__main', className);

    return (
        <main {...mainProps} className={classes}>{children}</main>
    );
};

PageMain.displayName = 'PageMain';
